import React from 'react';
import cx from 'classnames';

import Modal from '../../../../../../components/Modal/Modal';
import InfoTable from '../../../../../../components/table/InfoTable';
import { setDash, setNumberWithComma, setPhoneFormat } from '../../../../../../lib/common';
import { ACCOUNT_USER_STATUS_TEXT } from '../../../../../../constants/service/app/accountUserConstants';
import {
  INVALID_GENERATE_POINT_AMOUNT_CASE_TYPE_TEXT,
  INVALID_GENERATE_POINT_CASE_TEXT,
  INVALID_GENERATE_POINT_CAUSE_CASE_TYPE_TEXT,
  INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE_TEXT,
  INVALID_GENERATE_POINT_CREDIT_CASE_TYPE,
  INVALID_GENERATE_POINT_CREDIT_CASE_TYPE_TEXT,
  INVALID_GENERATE_POINT_TYPE_CASE_TYPE_TEXT,
  INVALID_GENERATE_POINT_USER_CASE_TYPE_TEXT,
  INVALID_GENERATE_POINT_USER_STATUS_CASE_TYPE_TEXT,
  POINT_LOG_TYPE_TEXT,
  VALID_GENERATE_POINT_CASE_TEXT,
} from '../../../../../../constants/service/app/pointConstants';

const GeneratePointValidFailModalView = (props) => {
  const { isOpen = true, validResult, closeModal, onOpenExcelBulkGeneratePointModal } = props;
  const { requestCnt, possibleCnt, impossibleCnt, userPointList, pointCauseSelectList, isBulk } = validResult;

  return (
    <Modal
      title="포인트 발급 실패"
      isOpen={isOpen}
      width={1550}
      height={600}
      isFooter={true}
      okText={isBulk ? '재업로드' : '확인'}
      onOk={isBulk ? onOpenExcelBulkGeneratePointModal : closeModal}
      onClose={() => closeModal()}
    >
      <div className="generate-point-valid-fail-modal-wrap">
        <div className="generate-point-valid-fail-title">
          <div className="summary">
            <span className="request">
              요청:
              <span>{requestCnt}</span>
            </span>
            <span className="possible">
              가능:
              <span>{possibleCnt}</span>
            </span>
            <span className="impossible">
              불가능:
              <span>{impossibleCnt}</span>
            </span>
          </div>

          <div>포인트 발급에 실패했습니다.</div>
          <div>아래 리스트에서 실패한 결과를 확인하시고,</div>
          <div>
            <span>수정을 한 뒤 다시 시도해주세요.</span>
          </div>
        </div>

        <div className="generate-point-valid-fail-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>발급 가능 여부</th>
                <th className="invalid-message">회원 번호</th>
                <th className="invalid-message">휴대전화 번호</th>
                <th className="invalid-message">회원 상태</th>
                <th className="invalid-message">내역 종류</th>
                <th className="invalid-message">적립/사용처</th>
                <th className="invalid-message">
                  적용 전 <br /> 사용가능한 포인트
                </th>
                <th className="invalid-message">
                  적용 전 <br /> 누적된 총 사용 포인트
                </th>
                <th className="invalid-message">입력한 액수</th>
                <th className="invalid-message">
                  적용 후 <br /> 사용가능한 포인트
                </th>
                <th className="invalid-message">
                  적용 후 <br /> 누적된 총 사용 포인트
                </th>
              </tr>
            </thead>
            <tbody>
              {userPointList.map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td
                    className={cx('tl', 'result', {
                      'is-invalid': item.isInvalid,
                    })}
                  >
                    {item.isInvalid ? INVALID_GENERATE_POINT_CASE_TEXT : VALID_GENERATE_POINT_CASE_TEXT}
                  </td>
                  <td className={cx('user', { 'is-invalid': item.userIsInvalid })}>
                    {setDash(item.userId)}
                    <div className="message">
                      {item.userIsInvalid ? INVALID_GENERATE_POINT_USER_CASE_TYPE_TEXT[item.userInvalidType] : ''}
                    </div>
                  </td>
                  <td className={cx('cell-phone', { 'is-invalid': item.cellPhoneIsInvalid })}>
                    {setDash(setPhoneFormat(item.cellPhone))}
                    <div className="message">
                      {item.cellPhoneIsInvalid
                        ? INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE_TEXT[item.cellPhoneInvalidType]
                        : ''}
                    </div>
                  </td>
                  <td className={cx('status', { 'is-invalid': item.statusIsInvalid })}>
                    {setDash(ACCOUNT_USER_STATUS_TEXT[item.status])}
                    <div className="message">
                      {item.statusIsInvalid
                        ? INVALID_GENERATE_POINT_USER_STATUS_CASE_TYPE_TEXT[item.statusInvalidType]
                        : ''}
                    </div>
                  </td>
                  <td className={cx('type', { 'is-invalid': item.typeIsInvalid })}>
                    {setDash(POINT_LOG_TYPE_TEXT[item.type])}
                    <div className="message">
                      {item.typeIsInvalid ? INVALID_GENERATE_POINT_TYPE_CASE_TYPE_TEXT[item.typeIsInvalidType] : ''}
                    </div>
                  </td>
                  <td className={cx('cause', { 'is-invalid': item.causeIsInvalid })}>
                    {item.pointCauseId
                      ? pointCauseSelectList.find((causeItem) => causeItem.id === item.pointCauseId).name
                      : null}
                    <div className="message">
                      {item.causeIsInvalid ? INVALID_GENERATE_POINT_CAUSE_CASE_TYPE_TEXT[item.causeIsInvalidType] : ''}
                    </div>
                  </td>
                  <td className="tc">{setNumberWithComma(item.pointAmount)}</td>
                  <td className="tc">{setNumberWithComma(item.usedPointAmount)}</td>
                  <td
                    className={cx('amount', {
                      'is-invalid': item.isInvalid,
                    })}
                  >
                    {setNumberWithComma(item.amount)}
                    <div className="message">
                      {item.amountIsInvalid
                        ? INVALID_GENERATE_POINT_AMOUNT_CASE_TYPE_TEXT[item.amountIsInvalidType]
                        : ''}
                    </div>
                  </td>
                  <td
                    className={cx('credit', {
                      'is-invalid':
                        item.creditIsInvalid &&
                        item.creditIsInvalidType === INVALID_GENERATE_POINT_CREDIT_CASE_TYPE.INVALID_AFTER_CREDIT,
                    })}
                  >
                    {setNumberWithComma(item.afterPointAmount)}
                    <div className="message">
                      {item.creditIsInvalid &&
                      item.creditIsInvalidType === INVALID_GENERATE_POINT_CREDIT_CASE_TYPE.INVALID_AFTER_CREDIT
                        ? INVALID_GENERATE_POINT_CREDIT_CASE_TYPE_TEXT[item.creditIsInvalidType]
                        : ''}
                    </div>
                  </td>
                  <td
                    className={cx('credit', {
                      'is-invalid':
                        item.creditIsInvalid &&
                        item.creditIsInvalidType === INVALID_GENERATE_POINT_CREDIT_CASE_TYPE.INVALID_AFTER_USED_CREDIT,
                    })}
                  >
                    {setNumberWithComma(item.afterUsedPointAmount)}
                    <div className="message">
                      {item.creditIsInvalid &&
                      item.creditIsInvalidType === INVALID_GENERATE_POINT_CREDIT_CASE_TYPE.INVALID_AFTER_USED_CREDIT
                        ? INVALID_GENERATE_POINT_CREDIT_CASE_TYPE_TEXT[item.creditIsInvalidType]
                        : ''}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default GeneratePointValidFailModalView;
